module.exports = "https://cwa.roocdn.com/_next/static/rider-cyclist.eca59dd3.png";